import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Form,
  Modal,
  Card,
  message,
  Spin,
  Space,
  Image,
  Row,
  Col,
  Divider,
  Empty,
  Tag,
  Table,
  Collapse,
  Tooltip,
  List,
  Avatar,
  Popconfirm,
  Input,
  Typography,
} from "antd";
import {
  FilePdfOutlined,
  FileSearchOutlined,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  HomeOutlined,
  CarOutlined,
  EyeOutlined,
  TeamOutlined,
  SearchOutlined,
  EnvironmentOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_CONTNO_DETAIL_SEARCH,
  HEADERS_EXPORT_DETAIL,
  POST_LOAD_MEMO_NEW,
  POST_LOAN_DB2,
  GET_GEO_ALL,
  POST_CLOSE_FIELD_COLLECTION,
  POST_INSERT_FIELD_COLLECTION_NOTE,
  POST_LIST_FIELD_COLLECTION_NOTE,
  POST_ACCEPT_FIELD_COLLECTION,
} from "../../../API/apiUrls";
import {
  getFileType,
  collapseBlankLines,
  formatMoney,
} from "../../contractDetail/contractDetailNew/utils";
import PdfPreviewModal from "../../contractDetail/contractDetailNew/components/PdfPreviewModal";
import AddImage from "../../contractDetail/modal/AddImage";

// ✅ แสดงเฉพาะ menuType/imageType ที่ยังใช้งานจริง (ที่ comment ปิดไว้ = เลิกใช้)
const getDocLabel = (menuType, imageType) => {
  // menuType 5 = คำฟ้อง
  if (menuType === 5 && imageType === 3)
    return { label: "ไฟล์คำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // if (menuType === 5 && imageType === 4)
  //   return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  // menuType 6 = ศาลตัดสิน
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 8)
    return { label: "คำพิพากษา(ทำยอม)", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 9)
    return { label: "ถอนฟ้อง", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 6 && imageType === 10)
  //   return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  if (menuType === 6 && imageType === 12)
    return { label: "วางคำบังคับ", color: "#096dd9" }; // น้ำเงินเข้ม
  // menuType 8 = ปิดบัญชี
  // if (menuType === 8 && imageType === 13)
  //   return { label: "ใบตัดจ่าย", color: "#096dd9" }; // น้ำเงินเข้ม
  // if (menuType === 8 && imageType === 14)
  //   return { label: "ใบเสร็จปิดบัญชี", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 9 && imageType === 16)
    return { label: "หมายตั้ง", color: "#096dd9" }; // น้ำเงินเข้ม
  // return { label: "เอกสาร", color: "#595959" }; // เทาเข้ม
};

const formatThaiDate = (d) =>
  d ? dayjs(d).add(543, "year").format("DD/MM/YYYY") : "-";

// ── บล็อกแสดงข้อมูล label บน / value ล่าง (สไตล์เดียวกับ "ข้อมูลลูกหนี้/ผู้ค้ำ") ──
const InfoField = ({ label, children }) => (
  <div style={{ fontSize: 13 }}>
    <div style={{ color: "#888" }}>{label}</div>
    <div style={{ fontWeight: 500 }}>{children}</div>
  </div>
);

// ── โซนเอกสาร ตรงกับ menuType ที่ loadPath ดึงมา (5, 6, 9) ─────
const ZONE_CONFIG = {
  5: {
    title: "เอกสารคำฟ้อง",
    color: "#d46b08",
    bg: "#fff7e6",
    border: "#ffd591",
  },
  6: {
    title: "เอกสารชั้นศาล",
    color: "#096dd9",
    bg: "#e6f4ff",
    border: "#91caff",
  },
  9: {
    title: "เอกสารหมายตั้ง",
    color: "#389e0d",
    bg: "#f6ffed",
    border: "#b7eb8f",
  },
};

// ── ประเภทเอกสารสิทธิ์ที่ดิน (judgeData.asset[].assetLand[].typeLand) ──
const LAND_TYPE_MAP = {
  1: "โฉนด",
  2: "นส.3ก.",
  3: "ห้องชุด",
  4: "อาคารชุด",
  5: "นภ.1",
  6: "อื่น ๆ",
};

// โซนระยะทาง: 1=(0-150กม.) / 2=(151-300กม.) / 3=(301-500กม.) / 4=(501-800กม.) / E=(800กม.ขึ้นไป)
const DISTANCE_ZONES = [
  { zone: 1, max: 150 },
  { zone: 2, max: 300 },
  { zone: 3, max: 500 },
  { zone: 4, max: 800 },
];

// ✅ ใช้ขอบเขตเดียวกับ getDistanceZone เพื่อแปลง zoneGrade กลับเป็นช่วงกิโลเมตร
const getDistanceZoneLabel = (zone) => {
  if (zone === "E") return "800 กม. ขึ้นไป";
  const idx = DISTANCE_ZONES.findIndex((z) => z.zone === zone);
  if (idx === -1) return null;
  const min = idx === 0 ? 0 : DISTANCE_ZONES[idx - 1].max + 1;
  return `${min}-${DISTANCE_ZONES[idx].max} กม.`;
};

const ZONE_GRADE_COLOR = { 1: "green", 2: "blue", 3: "orange", 4: "red" };

const { TextArea } = Input;

const RequestDocModal = ({ open, onCancel, dataDefault, onSuccess }) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");
  // const API_LINE_NOTI =
  //   "https://noti-lawyer-539174983798.asia-southeast1.run.app/api/notify/lawsuit/docs-complete";
  const API_LINE_NOTI =
    "  https://noti-lawyer-1024031113167.asia-southeast3.run.app/api/notify/lawsuit/docs-complete";

  const header = {
    "Content-Type": "application/json",
    "X-API-Key": "your-secret-key-here",
  };

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileListByContract, setFileListByContract] = useState([]);
  const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [isModalAddImge, setIsModalAddImge] = useState(false);
  const [judgeData, setJudgeData] = useState(null);
  const [memoDataOld, setMemoDataOld] = useState(null);
  const [loanData, setLoanData] = useState(null);
  const [loadingLoan, setLoadingLoan] = useState(false);
  const [checkingContract, setCheckingContract] = useState(false);
  const [contractCheckResult, setContractCheckResult] = useState(null);
  const [geoData, setGeoData] = useState(null);
  const [assetLandModal, setAssetLandModal] = useState({
    open: false,
    person: null,
  });
  const [addressModal, setAddressModal] = useState({
    open: false,
    person: null,
  });
  const [notes, setNotes] = useState([]);
  const [loadingNotes, setLoadingNotes] = useState(false);
  const [showNotes, setShowNotes] = useState(true);
  const [noteRemark, setNoteRemark] = useState("");
  const [closeModalOpen, setCloseModalOpen] = useState(false);
  const [closeRemark, setCloseRemark] = useState("");
  const [closing, setClosing] = useState(false);
  const [accepting, setAccepting] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    axios
      .get(GET_GEO_ALL, {
        headers: HEADERS_EXPORT_BEN,
        signal: controller.signal,
      })
      .then((res) => setGeoData(res.data))
      .catch((error) => {
        if (error.name !== "CanceledError") {
          console.error("Error loading geo data:", error);
        }
      });
    return () => controller.abort();
  }, []);

  const loadMemoDataOld = async (contno) => {
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    try {
      const res = await axios.post(POST_LOAD_MEMO_NEW, {
        contractNo: useContno,
      });
      if (res?.data) {
        const memo1 = collapseBlankLines(res.data.MEMO1);
        setMemoDataOld({ ...res.data, MEMO1: memo1 });
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadMemoDataOld:", error);
      }
    }
  };

  const loadLoanData = async (contno) => {
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    try {
      const res = await axios.post(
        POST_LOAN_DB2,
        { CONTNO: `'${useContno}'` },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res?.data?.[0]) setLoanData(res.data[0]);
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadLoanData:", error);
      }
    }
  };

  // ✅ เช็คว่าสัญญานี้มีข้อมูลในระบบเก่า (POST_LOAD_MEMO_NEW) หรือไม่
  const handleCheckContract = async () => {
    const contno = dataDefault?.contno;
    if (!contno) return;
    const useContno = /^V\d/.test(contno) ? contno.substring(1) : contno;
    setCheckingContract(true);
    try {
      const res = await axios.post(POST_LOAD_MEMO_NEW, {
        contractNo: useContno,
      });
      if (res?.data) {
        message.success("ถูกต้อง พบข้อมูลสัญญานี้ในระบบ");
        setContractCheckResult(true);
        const memo1 = collapseBlankLines(res.data.MEMO1);
        setMemoDataOld({ ...res.data, MEMO1: memo1 });
        loadLoanData(useContno);
      } else {
        message.warning("ไม่พบสัญญาในระบบใด ๆ กรุณาติดต่อ IT");
        setContractCheckResult(false);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error handleCheckContract:", error);
        message.warning("ไม่พบสัญญาในระบบใด ๆ กรุณาติดต่อ IT");
        setContractCheckResult(false);
      }
    } finally {
      setCheckingContract(false);
    }
  };

  const loadJudgeData = useCallback(async (payload) => {
    setLoadingLoan(true);
    try {
      const { data } = await axios.post(POST_CONTNO_DETAIL_SEARCH, payload, {
        headers: HEADERS_EXPORT_DETAIL,
      });

      if (!data) return;

      setJudgeData(data);

      const memoContno = data.judge?.[0]?.CONTNO;
      if (memoContno) {
        await Promise.all([
          loadMemoDataOld(memoContno),
          loadLoanData(memoContno),
        ]);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error loadJudgeData:", error);
        message.error("เกิดข้อผิดพลาดในการโหลดข้อมูลคดี");
      }
    } finally {
      setLoadingLoan(false);
    }
  }, []);

  // ✅ โหลดรายการบันทึกภาคสนาม
  const loadNotes = useCallback(
    async (id) => {
      setLoadingNotes(true);
      try {
        const { data } = await axios.post(
          POST_LIST_FIELD_COLLECTION_NOTE,
          {
            id,
            userId,
          },
          {
            headers: HEADERS_EXPORT_BEN,
          },
        );
        setNotes(Array.isArray(data?.data) ? data.data : []);
      } catch (error) {
        if (error.name !== "CanceledError") {
          console.error("Error loadNotes:", error);
        }
        setNotes([]);
      } finally {
        setLoadingNotes(false);
      }
    },
    [userId],
  );

  // ✅ เพิ่มบันทึกภาคสนาม
  const postFieldCollectionNote = async () => {
    if (!noteRemark) {
      message.warning("กรุณากรอกหมายเหตุก่อนบันทึก");
      return;
    }
    setLoadingNotes(true);
    try {
      const res = await axios.post(
        POST_INSERT_FIELD_COLLECTION_NOTE,
        {
          id: dataDefault.id,
          userId,
          note: noteRemark,
        },
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );
      if (res?.status === 200) {
        message.success("บันทึกหมายเหตุสำเร็จ");
        setNoteRemark("");
        await loadNotes(dataDefault.id);
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("Error postFieldCollectionNote:", error);
        message.error("เกิดข้อผิดพลาดในการบันทึกหมายเหตุ");
      }
    } finally {
      setLoadingNotes(false);
    }
  };

  // ✅ รับงาน
  const handleAcceptJob = async () => {
    setAccepting(true);
    try {
      const res = await axios.post(
        POST_ACCEPT_FIELD_COLLECTION,
        {
          ids: [dataDefault.id],
          userId,
        },
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );
      if (res?.status === 200) {
        message.success("รับงานสำเร็จ");
        handleClose();
        onSuccess?.();
      }
    } catch (error) {
      console.error("Error handleAcceptJob:", error);
      message.error(
        error.response?.data?.message || "เกิดข้อผิดพลาดในการรับงาน",
      );
    } finally {
      setAccepting(false);
    }
  };

  // ✅ ปิดงาน
  const handleCloseJob = async () => {
    if (!closeRemark.trim()) {
      message.warning("กรุณากรอกหมายเหตุการปิดงาน");
      return;
    }
    setClosing(true);
    try {
      const res = await axios.post(
        POST_CLOSE_FIELD_COLLECTION,
        {
          id: dataDefault.id,
          userId,
          closeRemark: closeRemark,
        },
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );
      if (res?.status === 200) {
        message.success("ปิดงานสำเร็จ");
        setCloseModalOpen(false);
        setCloseRemark("");
        handleClose();
        onSuccess?.();
      }
    } catch (error) {
      console.error("Error handleCloseJob:", error);
      message.error(
        error.response?.data?.message || "เกิดข้อผิดพลาดในการปิดงาน",
      );
    } finally {
      setClosing(false);
    }
  };

  // ✅ วันที่ชำระล่าสุดและจำนวนเงิน (รวมจาก chqtran + chqtran_arothr)
  const latestPayment = useMemo(() => {
    const rows = [
      ...(judgeData?.chqtran || []),
      ...(judgeData?.chqtran_arothr || []),
    ].filter((r) => r?.PAYDT);

    if (!rows.length) return null;

    return rows.reduce((latest, r) =>
      dayjs(r.PAYDT).isAfter(dayjs(latest.PAYDT)) ? r : latest,
    );
  }, [judgeData]);

  // ✅ loanNew มีข้อมูลใช้ loanNew, ถ้า loanJudge มีข้อมูลใช้ loanJudge, ถ้าไม่มีใช้ข้อมูลเดิม (chqtran)
  const loanFallback = judgeData?.loanNew || judgeData?.loanJudge || null;
  const latestPaymentDate = loanFallback
    ? loanFallback.LPAYD
    : latestPayment?.PAYDT;
  const latestPaymentAmount = loanFallback
    ? loanFallback.LPAYA
    : latestPayment?.NETPAY;

  const getProvinceDesc = useCallback(
    (provCode) => {
      if (provCode == null || provCode === "") return "-";
      const p = (geoData?.province || []).find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p?.provDesc || String(provCode);
    },
    [geoData?.province],
  );

  const getDistrictDesc = useCallback(
    (distCode, provCode) => {
      if (distCode == null || distCode === "") return "-";
      const d = (geoData?.district || []).find(
        (x) =>
          String(x.distCode) === String(distCode) &&
          (provCode == null || String(x.provCode) === String(provCode)),
      );
      return d?.distDesc || String(distCode);
    },
    [geoData?.district],
  );

  const getSubDistrictDesc = useCallback(
    (subDistCode, distCode, provCode) => {
      if (subDistCode == null || subDistCode === "") return "-";
      const s = (geoData?.subDistrict || []).find(
        (x) =>
          String(x.subDistCode) === String(subDistCode) &&
          (distCode == null || String(x.distCode) === String(distCode)) &&
          (provCode == null || String(x.provCode) === String(provCode)),
      );
      return s?.subDistDesc || String(subDistCode);
    },
    [geoData?.subDistrict],
  );

  // ✅ ปิด Modal และ Reset
  const handleClose = useCallback(() => {
    form.resetFields();
    onCancel?.();
  }, [form, onCancel]);

  // ✅ ส่งข้อมูล (docType: "enforce" = คำบังคับ, "summons" = หมายตั้ง)
  const sendNoti = async (docType) => {
    const docLabel = docType === "enforce" ? "คำบังคับ" : "หมายตั้ง";
    const payload = {
      case_no: dataDefault.newContno,
      case_name: dataDefault.SNAM + dataDefault.NAME1 + " " + dataDefault.NAME2,
      notify_to: [1, dataDefault.lawyerId],
      action_by: "ทีมชุดนอก",
      message: `ผู้สืบทรัพย์ร้องขอเอกสาร${docLabel}\nเลขคดีแดง ${dataDefault.redCaseNumber}\nศาล ${dataDefault.provincialCourt}`,
    };

    try {
      const res = await axios.post(API_LINE_NOTI, payload, {
        headers: header,
      });

      if (res.status === 200) {
        message.success(`ส่งคำร้องขอ${docLabel}สำเร็จ`);
        return { success: true, status: res.status };
      } else {
        message.error("ไม่สามารถส่งข้อมูลได้");
        return { success: false, error: "ไม่สามารถส่งข้อมูลได้" };
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMsg =
        error.response?.data?.message || "เกิดข้อผิดพลาดในการอัพเดทข้อมูล";
      message.error(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

  const loadPath = useCallback(async () => {
    setLoading(true);
    try {
      const [imgRes6, imgRes9] = await Promise.all([
        dataDefault.docEnforce || dataDefault.contno
          ? axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/6/${dataDefault.loanId}`, {
              headers: HEADERS_UPIMAGE,
            })
          : Promise.resolve({ data: [] }),
        dataDefault.docSeize
          ? axios.get(`${GET_LOAD_IMAGE_NEW_ALL}/9/${dataDefault.loanId}`, {
              headers: HEADERS_UPIMAGE,
            })
          : Promise.resolve({ data: [] }),
      ]);

      const mapImg = (img) => ({
        ...img,
        CONTNO: dataDefault.contno,
        loanId: dataDefault.loanId,
        lawsuitId: dataDefault.lawsuitId,
      });

      const allImages = [
        ...(imgRes6.data || []).map(mapImg),
        ...(imgRes9.data || []).map(mapImg),
      ];

      if (allImages.length === 0) {
        message.warning("ไม่พบรูปภาพ");
      }

      setFileListByContract(allImages);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาด: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  }, [dataDefault]);

  useEffect(() => {
    if (open) {
      loadPath();
    }
  }, [open, loadPath]);

  useEffect(() => {
    if (open && dataDefault) {
      loadJudgeData({
        CONTNO: dataDefault?.newContno || dataDefault?.contno,
      });
      loadNotes(dataDefault.id);
    }
  }, [open, dataDefault, loadJudgeData, loadNotes]);

  // ✅ เรียกใหม่หลังอัปโหลดรูปสำเร็จจาก AddImage
  const handleReload = () => {
    setFileListByContract([]);
    loadPath();
  };
  // ✅ แสดงเฉพาะเอกสารที่มี label (ไม่ใช่ประเภทที่ comment ปิดไว้) เรียงตาม menuType → imageType
  const sortedVisibleFiles = [...fileListByContract]
    .filter((file) => getDocLabel(file.menuType, file.imageType))
    .sort((a, b) =>
      a.menuType !== b.menuType
        ? a.menuType - b.menuType
        : a.imageType - b.imageType,
    );

  const zones = Object.keys(ZONE_CONFIG).map((menuType) => ({
    menuType: Number(menuType),
    files: sortedVisibleFiles.filter((f) => f.menuType === Number(menuType)),
  }));

  // ── card รูปภาพ ───────────────────────────────────────────────
  const renderImageCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);

    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <Image
            src={previewUrl}
            alt={file.path}
            style={{
              width: "100%",
              height: 80,
              objectFit: "cover",
              borderRadius: 4,
            }}
            preview={{
              mask: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <EyeOutlined style={{ fontSize: 14 }} />
                  <span style={{ fontSize: 10 }}>ดูรูป</span>
                </div>
              ),
            }}
          />
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── card PDF ──────────────────────────────────────────────────
  const renderPdfCard = (file) => {
    const previewUrl = `${GET_LOAD_IMAGE_NEW_BY}/${file.path}?token=${token}`;
    const { label, color } = getDocLabel(file.menuType, file.imageType);
    return (
      <Col key={file.imageId} xs={8} sm={6} md={4}>
        <div
          style={{
            border: `1px solid ${color}`,
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            background: "#fff",
          }}
        >
          <div
            onClick={() => {
              setPdfPreviewUrl(previewUrl);
              setPdfPreviewOpen(true);
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: 80,
              background: "#fff1f0",
              borderRadius: 6,
              border: "1px dashed #ff4d4f",
              gap: 4,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
          >
            <FilePdfOutlined style={{ fontSize: 32, color: "#ff4d4f" }} />
            <span style={{ fontSize: 11, color: "#ff4d4f", fontWeight: 500 }}>
              <EyeOutlined style={{ marginRight: 4 }} />
              ดู PDF
            </span>
          </div>
          <div
            style={{
              marginTop: 6,
              background: color,
              color: "#fff",
              fontSize: 11,
              borderRadius: 4,
              padding: "1px 6px",
              display: "inline-block",
            }}
          >
            {label}
          </div>
        </div>
      </Col>
    );
  };

  // ── กล่องโซนเอกสารตาม menuType ─────────────────────────────────
  const renderZone = ({ menuType, files }) => {
    if (!files.length) return null;
    const cfg = ZONE_CONFIG[menuType];
    const pdfFiles = files.filter((f) => getFileType(f.path) === "pdf");
    const imgFiles = files.filter((f) => getFileType(f.path) === "image");

    return (
      <div
        key={menuType}
        style={{
          border: `1px solid ${cfg.border}`,
          borderRadius: 10,
          padding: "12px 16px",
          marginBottom: 16,
          background: cfg.bg,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 12,
            paddingBottom: 8,
            borderBottom: `1px solid ${cfg.border}`,
          }}
        >
          <div
            style={{
              background: cfg.color,
              color: "#fff",
              borderRadius: 6,
              padding: "2px 12px",
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {cfg.title}
          </div>
          <span style={{ fontSize: 14, color: "#888" }}>
            {files.length} ไฟล์
          </span>
        </div>

        {imgFiles.length > 0 && (
          <>
            <div style={{ fontSize: 14, color: "#888", marginBottom: 6 }}>
              รูปภาพ ({imgFiles.length})
            </div>
            <Image.PreviewGroup>
              <Row
                gutter={[8, 8]}
                style={{ marginBottom: pdfFiles.length ? 12 : 0 }}
              >
                {imgFiles.map(renderImageCard)}
              </Row>
            </Image.PreviewGroup>
          </>
        )}

        {pdfFiles.length > 0 && (
          <>
            <div
              style={{
                fontSize: 14,
                color: "#888",
                marginBottom: 6,
                marginTop: imgFiles.length ? 4 : 0,
              }}
            >
              <FilePdfOutlined style={{ color: "#ff4d4f", marginRight: 4 }} />
              เอกสาร PDF ({pdfFiles.length})
            </div>
            <Row gutter={[8, 8]}>{pdfFiles.map(renderPdfCard)}</Row>
          </>
        )}
      </div>
    );
  };

  // ── ตารางทรัพย์ เรียงเป็นรายบุคคล (judgeData.asset) ───────────────
  const assetList = judgeData?.asset || [];

  const openAssetLandModal = (person) => {
    setAssetLandModal({ open: true, person });
  };

  const assetColumns = [
    {
      title: "ลำดับ",
      key: "i",
      align: "center",
      width: 50,
      render: (_, __, i) => i + 1,
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "name",
      render: (_, p) => (
        <div style={{ fontSize: 13 }}>
          <div style={{ fontWeight: 500 }}>
            {p.SNAM}
            {p.NAME1} {p.NAME2}
          </div>
          <div style={{ color: "#888" }}>เลขบัตร {p.CUSCOD || "-"}</div>
        </div>
      ),
    },
    {
      title: "สถานะ",
      key: "role",
      align: "center",
      width: 130,
      render: (_, p) => (
        <Tag color={p.garno === 0 ? "blue" : "default"}>
          {p.garno === 0 ? "ผู้เช่าซื้อ/ลูกหนี้" : `ผู้ค้ำ ${p.garno}`}
        </Tag>
      ),
    },
    {
      title: "ทรัพย์",
      key: "asset",
      align: "center",
      width: 150,
      render: (_, p) => {
        const landCount = (p.assetLand || []).length;
        return landCount > 0 ? (
          <Button
            size="small"
            type="link"
            onClick={() => openAssetLandModal(p)}
          >
            <Tag color="green">มีทรัพย์ ({landCount})</Tag>
          </Button>
        ) : (
          <Tag>ไม่มีทรัพย์</Tag>
        );
      },
    },
  ];

  // ✅ แสดงชื่อเจ้าของสัญญา
  const ownerName = dataDefault
    ? `${dataDefault.newContno || ""} / ${dataDefault.SNAM || ""}${
        dataDefault.NAME1 || ""
      } ${dataDefault.NAME2 || ""}`.trim()
    : "-";

  return (
    <Modal
      title={
        <Space>
          <span>รายละเอียดสัญญา</span>
          {(dataDefault?.stage === "สัญญานี้ยังไม่มีข้อมูลในโปรแกรมทนาย" ||
            dataDefault?.stage ===
              "ส่งสืบแล้ว รอผล ยังไม่ออกบอกเลิก ยังไม่ฟ้อง") && (
            <Tooltip title="เช็คสัญญาในระบบ">
              <Button
                type="text"
                size="small"
                shape="circle"
                icon={
                  contractCheckResult === true ? (
                    <CheckCircleTwoTone twoToneColor="#52c41a" />
                  ) : contractCheckResult === false ? (
                    <CloseCircleTwoTone twoToneColor="#ff4d4f" />
                  ) : (
                    <SearchOutlined />
                  )
                }
                loading={checkingContract}
                onClick={handleCheckContract}
              />
            </Tooltip>
          )}
        </Space>
      }
      open={open}
      onCancel={handleClose}
      width={850}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="กำลังบันทึก...">
        <Card>
          {loanData && (
            <Collapse
              defaultActiveKey={["debtor"]}
              style={{ marginBottom: 16 }}
              items={[
                {
                  key: "debtor",
                  label: (
                    <span>
                      <TeamOutlined /> ข้อมูลลูกหนี้/ผู้ค้ำ
                    </span>
                  ),
                  children: (
                    <Row gutter={[16, 16]}>
                      {loanData.CUSTOMER && (
                        <Col xs={24} md={12}>
                          <div style={{ fontSize: 13 }}>
                            <div style={{ color: "#888" }}>ลูกหนี้</div>
                            <div style={{ fontWeight: 500 }}>
                              {loanData.CUSTOMER.SNAM}
                              {loanData.CUSTOMER.NAME1}{" "}
                              {loanData.CUSTOMER.NAME2}
                            </div>
                            <div style={{ color: "#888" }}>
                              <Space size={4}>
                                <span>
                                  เลขบัตร {loanData.CUSTOMER.CUSCOD || "-"}
                                </span>
                                <Button
                                  size="small"
                                  type="link"
                                  icon={<EnvironmentOutlined />}
                                  onClick={() =>
                                    setAddressModal({
                                      open: true,
                                      person: loanData.CUSTOMER,
                                    })
                                  }
                                >
                                  ที่อยู่
                                </Button>
                              </Space>
                            </div>
                          </div>
                        </Col>
                      )}
                      {loanData.MORTGAGE &&
                        (loanData.MORTGAGE.GCODE === "FL" ? (
                          <Col xs={24} md={12}>
                            <div style={{ fontSize: 13 }}>
                              <div style={{ color: "#888" }}>
                                <HomeOutlined /> ที่ดิน (หลักประกัน)
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {getProvinceDesc(loanData.MORTGAGE.TYPE)}{" "}
                                {getDistrictDesc(
                                  loanData.MORTGAGE.MODEL,
                                  loanData.MORTGAGE.TYPE,
                                )}{" "}
                                {getSubDistrictDesc(
                                  loanData.MORTGAGE.BAAB,
                                  loanData.MORTGAGE.MODEL,
                                  loanData.MORTGAGE.TYPE,
                                )}
                              </div>
                              <div style={{ color: "#888" }}>
                                {loanData.MORTGAGE.COLOR || "-"} เลขที่{" "}
                                {loanData.MORTGAGE.STRNO || "-"}
                              </div>
                            </div>
                          </Col>
                        ) : (
                          <Col xs={24} md={12}>
                            <div style={{ fontSize: 13 }}>
                              <div style={{ color: "#888" }}>
                                <CarOutlined /> ยานพาหนะ
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {`${loanData.MORTGAGE.TYPE || ""} ${
                                  loanData.MORTGAGE.MODEL || ""
                                }`.trim() || "-"}
                              </div>
                              <div style={{ color: "#888" }}>
                                ทะเบียน {loanData.MORTGAGE.REGNO || "-"} ・ สี{" "}
                                {loanData.MORTGAGE.COLOR || "-"}
                              </div>
                              <div style={{ color: "#888" }}>
                                เลขตัวถัง {loanData.MORTGAGE.STRNO || "-"}
                              </div>
                            </div>
                          </Col>
                        ))}
                      {(loanData.GUARANTORS || []).length > 0 && (
                        <Col xs={24}>
                          <div
                            style={{
                              color: "#888",
                              fontSize: 13,
                              marginBottom: 4,
                            }}
                          >
                            ผู้ค้ำประกัน
                          </div>
                          <Space
                            direction="vertical"
                            size={4}
                            style={{ width: "100%" }}
                          >
                            {loanData.GUARANTORS.map((g, i) => (
                              <div key={g.CUSCOD || i} style={{ fontSize: 13 }}>
                                <span style={{ fontWeight: 500 }}>
                                  {g.SNAM}
                                  {g.NAME1} {g.NAME2}
                                </span>
                                <span style={{ color: "#888" }}>
                                  {" "}
                                  ({g.RELATN || "-"}) เลขบัตร {g.CUSCOD || "-"}
                                </span>
                                <Button
                                  size="small"
                                  type="link"
                                  icon={<EnvironmentOutlined />}
                                  onClick={() =>
                                    setAddressModal({ open: true, person: g })
                                  }
                                >
                                  ที่อยู่
                                </Button>
                              </div>
                            ))}
                          </Space>
                        </Col>
                      )}
                    </Row>
                  ),
                },
              ]}
            />
          )}

          <Collapse
            style={{ marginBottom: 16 }}
            items={[
              {
                key: "asset",
                label: (
                  <span>
                    <HomeOutlined /> ทรัพย์ (สืบทรัพย์ {assetList.length} ราย)
                  </span>
                ),
                children:
                  assetList.length > 0 ? (
                    <Table
                      size="small"
                      columns={assetColumns}
                      dataSource={assetList}
                      rowKey={(p) => p.assetOnlineId ?? p.customerId}
                      pagination={false}
                      scroll={{ x: 500 }}
                    />
                  ) : (
                    <Empty
                      description="ไม่พบข้อมูลทรัพย์"
                      style={{ margin: "16px 0" }}
                    />
                  ),
              },
            ]}
          />

          <Modal
            title={
              assetLandModal.person
                ? `ทรัพย์ (ที่ดิน) - ${assetLandModal.person.SNAM}${assetLandModal.person.NAME1} ${assetLandModal.person.NAME2}`
                : "ทรัพย์ (ที่ดิน)"
            }
            open={assetLandModal.open}
            onCancel={() => setAssetLandModal({ open: false, person: null })}
            footer={null}
            destroyOnHidden
          >
            <Table
              size="small"
              pagination={false}
              rowKey="landId"
              dataSource={assetLandModal.person?.assetLand || []}
              scroll={{ x: 600 }}
              columns={[
                {
                  title: "ลำดับ",
                  key: "i",
                  align: "center",
                  width: 50,
                  render: (_, __, i) => i + 1,
                },
                {
                  title: "ประเภท",
                  key: "type",
                  align: "center",
                  render: (_, a) => (
                    <Tag color="cyan">{LAND_TYPE_MAP[a.typeLand] || "-"}</Tag>
                  ),
                },
                {
                  title: "เลขที่ดิน",
                  key: "numberLand",
                  render: (_, a) => (
                    <div>
                      <strong>{a.numberLand || "-"}</strong>
                      {a.numberLandlawang && (
                        <span style={{ color: "#888" }}>
                          {" "}
                          (ระวาง {a.numberLandlawang})
                        </span>
                      )}
                    </div>
                  ),
                },
                {
                  title: "ที่ตั้ง",
                  key: "location",
                  render: (_, a) =>
                    `${a.provDesc || "-"} ${a.distDesc || ""} ${
                      a.subDistDesc || ""
                    }`.trim(),
                },
                {
                  title: "โซน",
                  key: "zoneGrade",
                  align: "center",
                  width: 70,
                  render: (_, a) =>
                    a.zoneGrade != null ? (
                      <Tag color={ZONE_GRADE_COLOR[a.zoneGrade] || "default"}>
                        โซน {a.zoneGrade} ({getDistanceZoneLabel(a.zoneGrade)})
                      </Tag>
                    ) : (
                      "-"
                    ),
                },
              ]}
            />
          </Modal>

          <Modal
            title={
              addressModal.person
                ? `ที่อยู่ - ${addressModal.person.SNAM}${addressModal.person.NAME1} ${addressModal.person.NAME2}`
                : "ที่อยู่"
            }
            open={addressModal.open}
            onCancel={() => setAddressModal({ open: false, person: null })}
            footer={null}
            destroyOnHidden
          >
            {(addressModal.person?.ADDRESS || []).length > 0 ? (
              <Space direction="vertical" size={12} style={{ width: "100%" }}>
                {addressModal.person.ADDRESS.map((addr, i) => (
                  <div key={addr.ADDRNO || i} style={{ fontSize: 13 }}>
                    <div style={{ fontWeight: 500 }}>
                      {addr.ADDR1} {addr.ADDR2}
                      {addr.MOOBAN && ` หมู่บ้าน${addr.MOOBAN}`}
                      {addr.SOI && ` ซอย${addr.SOI}`}
                    </div>
                    <div style={{ color: "#888" }}>
                      ตำบล{addr.TUMB || "-"} อำเภอ{addr.AUMPDES || "-"} จังหวัด
                      {addr.PROVDES || "-"} {addr.ZIP || ""}
                    </div>
                    {addr.TELP && (
                      <div style={{ color: "#888" }}>โทร {addr.TELP}</div>
                    )}
                  </div>
                ))}
              </Space>
            ) : (
              <Empty description="ไม่พบข้อมูลที่อยู่" />
            )}
          </Modal>

          <Form form={form}>
            <Collapse
              defaultActiveKey={["case"]}
              style={{ marginBottom: 16 }}
              items={[
                {
                  key: "case",
                  label: (
                    <span>
                      <FileSearchOutlined /> ข้อมูลคดี
                    </span>
                  ),
                  children: (
                    <Row gutter={[16, 16]}>
                      <Col xs={12}>
                        <InfoField label="เลขสัญญา/เจ้าของสัญญา">
                          {ownerName}
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="ศาล">
                          {dataDefault?.provincialCourt || "-"}
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="หมายเลขคดีแดง">
                          {dataDefault?.redCaseNumber || "-"}
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="วันที่พิพากษา">
                          {formatThaiDate(dataDefault?.judgeDate)}
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="วันชำระครั้งแรก">
                          {formatThaiDate(judgeData?.judge?.[0]?.firstDate)}
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="ชำระล่าสุด">
                          <Spin spinning={loadingLoan} size="small">
                            {latestPayment ? (
                              <Space>
                                <Tag color="green">
                                  {formatThaiDate(latestPayment.PAYDT)}
                                </Tag>
                                <span style={{ color: "#389e0d" }}>
                                  {formatMoney(latestPayment.NETPAY)} บาท
                                </span>
                              </Space>
                            ) : (
                              <span style={{ color: "#888", fontWeight: 400 }}>
                                ยังไม่มีการชำระ
                              </span>
                            )}
                          </Spin>
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="คำบังคับ">
                          <Space>
                            <Tag
                              color={
                                dataDefault?.enforceCaseDate
                                  ? "green"
                                  : "default"
                              }
                            >
                              {dataDefault?.enforceCaseDate
                                ? "อัพแล้ว"
                                : "ยังไม่อัพ"}
                            </Tag>
                            <span style={{ color: "#888", fontWeight: 400 }}>
                              {formatThaiDate(dataDefault?.enforceCaseDate)}
                            </span>
                          </Space>
                        </InfoField>
                      </Col>
                      <Col xs={24} md={12}>
                        <InfoField label="หมายตั้ง">
                          <Space>
                            <Tag
                              color={dataDefault?.docDate ? "green" : "default"}
                            >
                              {dataDefault?.docDate ? "อัพแล้ว" : "ยังไม่อัพ"}
                            </Tag>
                            <span style={{ color: "#888", fontWeight: 400 }}>
                              {formatThaiDate(dataDefault?.docDate)}
                            </span>
                          </Space>
                        </InfoField>
                      </Col>
                    </Row>
                  ),
                },
              ]}
            />

            {memoDataOld?.MEMO1 && (
              <Collapse
                ghost
                size="small"
                defaultActiveKey={["memo-old"]}
                style={{ marginBottom: 8 }}
                items={[
                  {
                    key: "memo-old",
                    label: "บันทึก Smart-link",
                    children: (
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          fontSize: 13,
                          color: "#595959",
                        }}
                      >
                        {memoDataOld.MEMO1}
                      </div>
                    ),
                  },
                ]}
              />
            )}

            <Divider orientation="left">
              <Space>
                <Typography.Text
                  strong
                  onClick={() => {
                    setShowNotes(!showNotes);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  บันทึกภาคสนาม
                </Typography.Text>
                <Tag
                  color="blue"
                  onClick={() => {
                    setShowNotes(!showNotes);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {notes.length} รายการ{" "}
                  {!showNotes ? <DownSquareOutlined /> : <UpSquareOutlined />}
                </Tag>
              </Space>
            </Divider>
            {showNotes && (
              <>
                <List
                  style={{
                    marginBottom: 16,
                    borderRadius: 8,
                    overflow: "hidden",
                  }}
                  bordered
                  loading={loadingNotes}
                  dataSource={notes}
                  locale={{ emptyText: "ไม่มีข้อมูลหมายเหตุ" }}
                  renderItem={(item, index) => (
                    <List.Item
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f7ff" : "#ffffff",
                        padding: "12px 16px",
                        alignItems: "flex-start",
                      }}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#1890ff" : "#096dd9",
                              fontWeight: "bold",
                            }}
                          >
                            {item?.createdByName}
                          </Avatar>
                        }
                        title={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: 4,
                            }}
                          >
                            <Space size={6}>
                              <Typography.Text
                                strong
                                style={{ color: "#1a365d" }}
                              >
                                {item?.createdByName} :
                              </Typography.Text>
                              <Tag
                                color="blue"
                                style={{ borderRadius: 10, fontSize: 11 }}
                              >
                                {dayjs(item?.CreatedAt).format(
                                  "DD/MM/YYYY HH:mm",
                                )}
                              </Tag>
                            </Space>
                            <Typography.Text
                              copyable={{
                                text: `${item?.note}\n ${dayjs(item?.CreatedAt).format("DD/MM/YYYY HH:mm")} [${item?.USERNAME}]`,
                                tooltips: ["คัดลอก", "คัดลอกแล้ว!"],
                              }}
                              style={{ fontSize: 12, color: "#888" }}
                            />
                          </div>
                        }
                        description={
                          <Typography.Text
                            style={{
                              fontSize: 13,
                              color: "#333",
                              whiteSpace: "pre-wrap",
                              lineHeight: 1.7,
                            }}
                          >
                            {item?.note}
                          </Typography.Text>
                        }
                      />
                    </List.Item>
                  )}
                />
                <TextArea
                  placeholder="กรอกหมายเหตุ (ถ้ามี)"
                  value={noteRemark}
                  onChange={(e) => setNoteRemark(e.target.value)}
                  rows={5}
                  showCount
                  maxLength={500}
                  style={{ marginBottom: "20px" }}
                />
                <Row>
                  <Col span={24} style={{ textAlign: "center" }}>
                    <Popconfirm
                      placement="topLeft"
                      title="เพิ่มบันทึกภาคสนาม"
                      description="กรุณาตรวจสอบข้อมูลให้เรียบร้อย ไม่สามารถแก้ไขสิ่งที่ได้บันทึกได้!"
                      onConfirm={postFieldCollectionNote}
                      okText="ยืนยัน"
                      cancelText="ปิด"
                      okButtonProps={{ size: "large" }}
                      cancelButtonProps={{ size: "large" }}
                    >
                      <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        disabled={!noteRemark}
                      >
                        บันทึก
                      </Button>
                    </Popconfirm>
                  </Col>
                </Row>
              </>
            )}

            <Divider orientation="left" style={{ marginTop: 24 }}>
              <FileSearchOutlined /> เอกสาร
            </Divider>

            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 12,
              }}
            >
              <Button
                icon={<UploadOutlined />}
                type="primary"
                ghost
                onClick={() => setIsModalAddImge(true)}
              >
                อัปโหลดรูป/ไฟล์
              </Button>
            </div> */}

            {sortedVisibleFiles.length > 0 ? (
              zones.map(renderZone)
            ) : (
              <Empty description="ไม่มีเอกสาร" style={{ margin: "24px 0" }} />
            )}

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Space wrap style={{ justifyContent: "center" }}>
                <Button onClick={handleClose} danger>
                  ยกเลิก
                </Button>
                {!dataDefault.docEnforce && (
                  <Button
                    variant="outlined"
                    color="orange"
                    onClick={() => sendNoti("enforce")}
                  >
                    ร้องขอคำบังคับ
                  </Button>
                )}
                {!dataDefault.docSeize && (
                  <Button
                    variant="outlined"
                    color="blue"
                    onClick={() => sendNoti("summons")}
                  >
                    ร้องขอหมายตั้ง
                  </Button>
                )}
                <Popconfirm
                  title="ยืนยันการรับงาน?"
                  okText="ยืนยัน"
                  cancelText="ยกเลิก"
                  onConfirm={handleAcceptJob}
                  disabled={
                    (!dataDefault.docEnforce && !dataDefault.docSeize) ||
                    !!dataDefault.acceptFollow
                  }
                >
                  <Button
                    variant="outlined"
                    color="green"
                    loading={accepting}
                    disabled={
                      (!dataDefault.docEnforce && !dataDefault.docSeize) ||
                      !!dataDefault.acceptFollow
                    }
                  >
                    {dataDefault.acceptFollow ? "รับงานแล้ว" : "รับงาน"}
                  </Button>
                </Popconfirm>
                <Button
                  variant="outlined"
                  color="green"
                  onClick={() => setCloseModalOpen(true)}
                >
                  ปิดงาน
                </Button>
              </Space>
            </div>
          </Form>
        </Card>
      </Spin>

      <Modal
        title="ปิดงาน"
        open={closeModalOpen}
        onCancel={() => {
          setCloseModalOpen(false);
          setCloseRemark("");
        }}
        onOk={handleCloseJob}
        okButtonProps={{ loading: closing }}
        okText="ยืนยันปิดงาน"
        cancelText="ยกเลิก"
        destroyOnHidden
      >
        <TextArea
          rows={4}
          placeholder="กรอกหมายเหตุการปิดงาน"
          value={closeRemark}
          onChange={(e) => setCloseRemark(e.target.value)}
          maxLength={500}
          showCount
        />
      </Modal>

      <PdfPreviewModal
        open={pdfPreviewOpen}
        url={pdfPreviewUrl}
        onClose={() => {
          setPdfPreviewOpen(false);
          setPdfPreviewUrl("");
        }}
      />

      {isModalAddImge && (
        <AddImage
          open={isModalAddImge}
          close={() => setIsModalAddImge(false)}
          dataDefault={{ judge: [dataDefault] }}
          onSuccess={handleReload}
        />
      )}
    </Modal>
  );
};

export default RequestDocModal;
